// EXTERNAL
import { useHistory, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

// CSS
import "./FrontPage.css"

// COMPONENTS
import BigPrimaryButton from "../components/BigPrimaryButton.js"
import LabelledInputBox from "../components/LabelledInputBox.js"
import BrandingPanel from "../components/BrandingPanel.js";
import SubmitButton from "../components/SubmitButton.js"
import InfoBox from "../components/InfoBox.js"

// SERVICES
import TokenManager from "../services/createTokenManager.js"

/** 
 * This component renders the login page.
 * 
 * @returns {ReactElement} A React element that renders the login page. 
 */
export default function LoginPage({}) {
  const approvedOrigins = process.env.REACT_APP_APPROVED_ORIGINS.split(",");
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const reason = queryParams.get('reason');
  const reasonMessages = {
    'new-user': "Sign up successful! Sign in to your new account below.",
    'reset-password-request': "A password reset link has been sent to your email address.",
    'reset-password': "Your password has been succesfully reset. Sign in below.",
    'changed-password': "Your password has been succesfully changed. Sign in below."
  };
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  useEffect(() => {
    if (reason) {
      setPopupMessage(reasonMessages[reason]);
      setShowPopup(true);
    }
  }, [reason])
  
  const handleLogIn = async (e) => {
    const userData = document.forms["Log In"].elements;

    const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/auth/jwt/create/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(
        {
          email: userData["Email"].value, 
          password: userData["Password"].value,
        }),
    })

    if (response.status == 200) {
      setShowPopup(false);
      const responseData = await response.json();
      TokenManager.setToken(responseData["access"]);
      
      const decodedToken = jwtDecode(responseData["access"]);
      if (decodedToken["has_dummy_pass"]) {
        history.push("/password-set");
      }

      if (window.self !== window.parent) {
        const parentOrigin = document.referrer ? new URL(document.referrer).origin : null;
        if (parentOrigin && approvedOrigins.includes(parentOrigin)) {
            window.parent.postMessage(responseData, parentOrigin);
        } else {
            console.error("Unauthorized or missing parent origin!");
        }
      }

    } else {
      const errorData = await response.json();
      setPopupMessage(Object.values(errorData)[0]);
      setShowPopup(true);
    }
  }

  return (
    <div className="front-page-body">
      <BrandingPanel></BrandingPanel>
      <div className="front-page-content">
        <InfoBox boxStyle="default" isVisible={showPopup} onClose={() => setShowPopup(false)}>{popupMessage}</InfoBox>
        <form className="front-page-form" name="Log In" action={handleLogIn}>
          <h2>Log In to Aroa</h2>
          <div className="front-page-vertical-labelled-input-boxes">
            <LabelledInputBox label="Email" type="email" placeholder="Email" required={true}></LabelledInputBox>
            <LabelledInputBox label="Password" type="password" placeholder="Password" required={true}></LabelledInputBox>
          </div>
          <div className="front-page-button-group">
            <SubmitButton buttonStyle="secondary">Log In</SubmitButton>
            <BigPrimaryButton buttonStyle="secondary" onClick={() => history.push("/password-reset")}>Forgot Password</BigPrimaryButton>
          </div>
          <div className="front-page-form-divider"></div>
          <div className="front-page-form-switch">
            <b>Don't have an account?</b>
            <BigPrimaryButton buttonStyle="secondary" onClick={() => history.push("/signup")}>Sign Up</BigPrimaryButton>
          </div>
        </form>
        <div className="copyright">{`© Korotu Technology ${process.env.REACT_APP_COPYRIGHT_YEAR}`}</div>
      </div>
    </div>
  )
}
